import {colors} from 'shells/colors/colors';

import {Button} from '../../button/button';
import {BookRegularIcon} from '../../icon/svg/book-regular-icon';
import {Illustration} from '../../illustrations/illustration';
import {Stack} from '../../layout/stack/stack';
import {Link} from '../../link/link';
import {Body} from '../../typography/body';

type Props = {
    illustrationSrc: string;
    description: string;
    learnMoreHref: string;
    cta: {
        label: string;
        onClick: () => void;
    };
};

export function NeedsSetupEmptyState(props: Props) {
    return (
        <div className='flex flex-dir-col align-center px-32 gap-12'>
            <Stack spacing={0}>
                <Illustration src={props.illustrationSrc} height={90} />
                <Body color='light' size='small' textAlign='center'>
                    {props.description}
                </Body>
            </Stack>
            <Stack isHorizontal={true} spacing={16} justifyContent='center' alignItems='center'>
                <Link href={props.learnMoreHref} newTab={true} variant='primary' size='small'>
                    <Stack isHorizontal={true} spacing={8} alignItems='center'>
                        {/* @ts-expect-error */}
                        <BookRegularIcon size={16} color={colors.blue} alignCenter={true} />
                        Learn more
                    </Stack>
                </Link>
                <Button variant='primary' size='small' onClick={props.cta.onClick}>
                    {props.cta.label}
                </Button>
            </Stack>
        </div>
    );
}
